import {
  ChangeEvent,
  useCallback,
} from "react";
import "./settings-dialog.scss";
import { useLiveAPIContext } from "../../contexts/LiveAPIContext";
import VoiceSelector from "./VoiceSelector";
import AvatarSelector from "./AvatarSelector";
import { LiveConnectConfig } from "@google/genai";
import cn from "classnames";
import { useSettingsStore } from "../../lib/store-settings";

export default function SettingsDialog({ showButton = true }: { showButton?: boolean }) {
  const { settingsOpen: open, closeSettings, openSettings, persona: promptInput, setPersona: setPromptInput } = useSettingsStore();
  const { config, setConfig, connected } = useLiveAPIContext();

  const handleFileUpload = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (ev) => {
      const text = ev.target?.result as string;
      setPromptInput(text);
    };
    reader.readAsText(file);
  }, [setPromptInput]);

  const handleSave = useCallback(() => {
    if (!promptInput.trim()) {
      closeSettings();
      return;
    }

    const systemInstruction = promptInput.trim();

    const newConfig: LiveConnectConfig = {
      ...config,
      systemInstruction: {
        parts: [{ text: systemInstruction }]
      },
    };

    setConfig(newConfig);
    closeSettings();
  }, [promptInput, config, setConfig, closeSettings]);


  return (
    <div className={cn("settings-dialog", { open })}>
      {showButton && (
        <button
          className="action-button material-symbols-outlined"
          onClick={() => open ? closeSettings() : openSettings()}
        >
          settings
        </button>
      )}
      <div className="dialog-overlay" onClick={closeSettings} style={{ display: open ? "block" : "none" }} />
      <dialog className="dialog" style={{ display: open ? "block" : "none" }}>
        <div className={`dialog-container ${connected ? "disabled" : ""}`}>
          <div className="dialog-header">
            <h2>Simülasyon Ayarları</h2>
            <button
              className="material-symbols-outlined close-button"
              onClick={closeSettings}
            >
              close
            </button>
          </div>
          {connected && (
            <div className="connected-indicator">
              <p>Bağlantı devam ederken ayarları değiştiremezsiniz.</p>
            </div>
          )}

          <div className="settings-content">
            <div className="mode-selectors">
              <VoiceSelector />
              <div style={{ marginTop: '12px' }}>
                <AvatarSelector />
              </div>
            </div>

            <div className="json-section">
              <label>Simülasyon Talimatı / Persona</label>
              <div className="file-upload">
                <input
                  type="file"
                  accept=".txt,.json"
                  onChange={handleFileUpload}
                  id="json-upload"
                  className="hidden-input"
                />
                <label htmlFor="json-upload" className="upload-button">
                  <span className="material-symbols-outlined">upload_file</span>
                  Dosya Yükle
                </label>
              </div>
              <textarea
                value={promptInput}
                onChange={(e) => setPromptInput(e.target.value)}
                placeholder="Persona tanımını veya yapay zeka talimatlarını buraya yazın..."
                rows={15}
                className="json-textarea"
                spellCheck={false}
              />
            </div>
          </div>

          <div className="dialog-footer">
            <button className="save-button" onClick={handleSave}>Kaydet ve Uygula</button>
          </div>
        </div>
      </dialog>
    </div>
  );
}
